import type { RegistryEntry } from '../types';

// OpenAI 系列
export const openaiConfigs: Record<string, RegistryEntry> = {
  'gpt-image-2.5-flare': {
    options: [
      {
        key: 'quality',
        label: 'Gen Quality',
        type: 'select',
        options: [
          { label: 'Medium', value: 'medium' },
          { label: 'High', value: 'high' },
          { label: 'X-High', value: 'xhigh' },
          { label: 'Max', value: 'max' },
        ],
        default: 'medium',
        group: 'inline',
      },
      {
        key: 'output_format',
        label: 'Output Format',
        type: 'select',
        options: [
          { label: 'PNG', value: 'png' },
          { label: 'JPEG', value: 'jpeg' },
          { label: 'WebP', value: 'webp' },
        ],
        default: 'png',
        group: 'basic',
      },
      {
        key: 'background',
        label: 'Background',
        type: 'select',
        options: [
          { label: 'Auto', value: 'auto' },
          { label: 'Opaque', value: 'opaque' },
          { label: 'Transparent', value: 'transparent' },
        ],
        default: 'auto',
        group: 'basic',
      },
    ],
    toProviderOptions: (ui) => ({
      quality: typeof ui.quality === 'string' ? ui.quality : 'medium',
      output_format: typeof ui.output_format === 'string' ? ui.output_format : 'png',
      background: typeof ui.background === 'string' ? ui.background : 'auto',
    } as unknown as Record<string, Record<string, any>>),
  },
  'gpt-image-2.5-sunburst': {
    options: [
      {
        key: 'quality',
        label: 'Gen Quality',
        type: 'select',
        options: [
          { label: 'Medium', value: 'medium' },
          { label: 'High', value: 'high' },
          { label: 'X-High', value: 'xhigh' },
          { label: 'Max', value: 'max' },
        ],
        default: 'medium',
        group: 'inline',
      },
      {
        key: 'output_format',
        label: 'Output Format',
        type: 'select',
        options: [
          { label: 'PNG', value: 'png' },
          { label: 'JPEG', value: 'jpeg' },
          { label: 'WebP', value: 'webp' },
        ],
        default: 'png',
        group: 'basic',
      },
      {
        key: 'background',
        label: 'Background',
        type: 'select',
        options: [
          { label: 'Auto', value: 'auto' },
          { label: 'Opaque', value: 'opaque' },
          { label: 'Transparent', value: 'transparent' },
        ],
        default: 'auto',
        group: 'basic',
      },
    ],
    toProviderOptions: (ui) => ({
      quality: typeof ui.quality === 'string' ? ui.quality : 'medium',
      output_format: typeof ui.output_format === 'string' ? ui.output_format : 'png',
      background: typeof ui.background === 'string' ? ui.background : 'auto',
    } as unknown as Record<string, Record<string, any>>),
  },
  'gpt-image-2-official': {
    options: [
      {
        key: 'quality',
        label: 'Gen Quality',
        type: 'select',
        options: [
          // { label: 'Low', value: 'low' },
          { label: 'Medium', value: 'medium' },
          { label: 'High', value: 'high' },
        ],
        default: 'medium',
        group: 'inline',
      },
      {
        key: 'output_format',
        label: 'Output Format',
        type: 'select',
        options: [
          { label: 'PNG', value: 'png' },
          { label: 'JPEG', value: 'jpeg' },
          { label: 'WebP', value: 'webp' },
        ],
        default: 'png',
        group: 'basic',
      },
      {
        key: 'background',
        label: 'Background',
        type: 'select',
        options: [
          { label: 'Auto', value: 'auto' },
          { label: 'Transparent', value: 'transparent' },
        ],
        default: 'auto',
        group: 'basic',
      },
    ],
    toProviderOptions: (ui) => ({
      quality: typeof ui.quality === 'string' ? ui.quality : 'medium',
      output_format: typeof ui.output_format === 'string' ? ui.output_format : 'png',
      background: typeof ui.background === 'string' ? ui.background : 'auto',
    } as unknown as Record<string, Record<string, any>>),
  },
};
